// extracted by mini-css-extract-plugin
export default {"inputHeader":"DeleteUserModal_inputHeader__VVViC","firstHeader":"DeleteUserModal_firstHeader__Jn1BG","warningButton":"DeleteUserModal_warningButton__VyQ5n"};